import React from "react";

const RefundPolicy = () => {
  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center p-6 mt-16">
      <div className="bg-white shadow-lg rounded-lg w-5/6 max-w-6xl p-10">
        <h1 className="text-4xl font-bold text-center text-gray-800 mb-6">Refund Policy</h1>

        <section className="mb-8">
          <p className="text-gray-600">
            - All payments are <strong>final</strong>, and <strong>no refunds</strong> will be provided once a form is submitted.  
            - Users must verify the <strong>accuracy</strong> of their details before submission.  
            - If technical issues occur, users may <strong>contact support</strong> via email or phone for resolution.  
          </p>
        </section>

        <div className="text-center mt-6">
          <a href="/" className="text-blue-500 hover:underline text-lg">← Go Back</a>
        </div>
      </div>
    </div>
  );
};

export default RefundPolicy;
